export default {
  title: 'Raport podpisanych / aktywnych',
  column_groups: {
    current_period: 'Bieżący okres',
  },
  fields: {
    name: 'Nazwa',
    area: 'Obszar',
    signed: 'Podpisane',
    live: 'Aktywne',
    going_live: 'Uruchamianie',
    going_live_avg: 'Śr. uruchamianie',
    churned: 'Utracone',
    not_live: 'Nieaktywne',
    live_ratio: 'Wskaźnik aktywnych',
    avg_mrr: 'Śr. MRR',
  },
  manager_status_filters: {
    active: 'Aktywne',
    inactive: 'Nieaktywne',
    all: 'Wszystkie',
  },
  status_filters: {
    all: 'Wszystkie',
    not_live: 'Nieaktywne',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restauracja',
    subtitle_few: '{{count}} restauracje',
    subtitle_many: '{{count}} restauracji',
    subtitle_other: '{{count}} restauracji',
    empty: 'Nie znaleziono restauracji.',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych, odśwież stronę',
  },
};
